import { useContext } from 'react';
import { RouterProvider } from '@tanstack/react-router';

import { router } from '../router.tsx';
import { Auth0Context } from '../lib/auth/auth0-context';
import { queryClient } from '../lib/api/query-client-provider';
import { useApi } from '../lib/api/use-api';

export const AuthenticatedRouterProvider = () => {
    const auth = useContext(Auth0Context);
    const api = useApi();

    if (auth?.isLoading) {
        return null;
    }

    return <RouterProvider router={router} context={{ auth: auth!, queryClient, api }}/>
};
